import { React, useState, useEffect } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import DashboardShortCuts from "../components/dashboardAndWAHComponent/common/DashboardShortCuts";
import calander from "../assets/calander.svg";
import downloadImg from "../assets/download-img.svg";
import CalendarComponent from "../components/CalendarCopmonent";
import DashboardAndWAHDirectoryComponent from "../components/Common/DirectoryComponent";
import BidOpportunityComponent from "../components/dashboardAndWAHComponent/common/BidOpportunityComponent";
import { Modal, Button } from "react-bootstrap";
import Forbidden403 from "./page403";

export default function CCN() {
  const [selectedState, setSelectedState] = useState();
  const [StateListFromLocalStorage, setStateListFromLocalStorage] = useState([]);
  const [userType, setUserType] = useState(false);
  const [storedState, setstoredState] = useState(
    JSON.parse(localStorage.getItem("selectedState"))
  );
  const [calendarEmail, setCalendarEmail] = useState("");
  const [showHelpModal, setShowHelpModal] = useState(false);

  const transformData = (items) =>
    items.map(({ id, name }) => ({
      value: id,
      label: name,
    }));

  useEffect(() => {
    const userData = JSON.parse(
      localStorage.getItem("loggedInUserInfo") || "{}"
    );

    const userType = userData?.user_type;
    setUserType(userType);

    const transformedData = transformData(userData?.state || []);
    setStateListFromLocalStorage(transformedData);

    if (!storedState && transformedData.length > 0) {
      localStorage.setItem("selectedState", JSON.stringify(transformedData[0]));
      setSelectedState(transformedData[0]);
    }

    if (userData?.email) {
      setCalendarEmail(userData.email);
    }
  }, []);

  // Guard route access
  if (userType !== false && userType !== "CCN_Internal") {
    return <Forbidden403 />;
  }

  const handleClose = () => setShowHelpModal(false);
  const handleShow = () => setShowHelpModal(true);

  return (
    <>
      <Header from="CCN Dashboard"/>
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
            <div className="col col-md-auto bg-primary mb-3">
              <h1 className="text-secondary fw-boldest point-42">
                My Dashboard
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-3 clearfix">
        <div className="container mt-n20">
          <div className="row">
            <div className="col-12 col-md-8 pb-4">
              <div className="card w-100 h-100 bg-white rounded-3 shadow-sm mb-4 border-0">
                <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-light border-2">
                  <div className="row g-0">
                    <div className="col g-0">
                      <h3 className="p-3 mb-0 pb-0 point-22 text-uppercase text-primary fw-bold">
                        Quick Links
                      </h3>
                    </div>
                    <div className="col-auto bg-secondary">
                      <div className="rounded-pill bg-secondary w-100">
                        <div className="d-flex flex-column justify-content-center">
                          <img
                            src={downloadImg}
                            className="header-icon m-2"
                            alt="logo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body p-3">
                  <div className="row g-3">
                    {/* Quick Links */}
                    <div className="col-md-4">
                      <a
                        href="https://alletting.dot.state.al.us/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        ALDOT Lettings
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://auth-us.surveymonkey.com/login?state=hKFo2SBaZz..."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        Survey Monkey
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://app.e2ma.net/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        Emma
                      </a>
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        onClick={() => console.log("Suite CRM clicked")}
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        Suite CRM
                      </button>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://www.godaddy.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        GoDaddy
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://ui.bidx.com/login"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        BidX
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://tasksboard.com/app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        Tasks Board
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://login.procore.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        Procore
                      </a>
                    </div>
                    <div className="col-md-4">
                      <a
                        href="https://www.elationsys.com/APP/Index.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary text-white rounded-5 fw-bold point-16 px-4 w-100 text-uppercase"
                      >
                        elations
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DashboardShortCuts type={"CCN"} />
          </div>
          <div className="row">
            <div className="col col-md-4">
              <DashboardAndWAHDirectoryComponent />
            </div>
            <div className="col col-md-8">
              <BidOpportunityComponent type="CCN" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card w-100 bg-white rounded-3 shadow-sm mb-4">
                <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-light border-2">
                  <div className="row g-0 align-items-center">
                    <div className="col">
                      <div className="px-3 py-2">
                        <h3 className="mb-0 point-22 text-uppercase text-primary fw-bold">
                          My Google Calendar
                        </h3>
                      </div>
                    </div>
                    <div className="col-auto  d-flex align-items-center me-3">
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none p-0 pt-1"
                        style={{ fontSize: "0.85rem" }}
                        onClick={handleShow}
                      >
                        Having trouble? Click here for help
                      </button>
                    </div>
                    <div className="col-auto bg-secondary d-flex align-items-center">
                      <img
                        src={calander}
                        className="header-icon m-2"
                        alt="Google Calendar Icon"
                        style={{ height: "40px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-body p-3">
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={`https://calendar.google.com/calendar/u/0/embed?src=${encodeURIComponent(
                        calendarEmail
                      )}&ctz=America/Chicago`}
                      title="Google Calendar"
                      style={{ border: 0 }}
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Help */}
      <Modal show={showHelpModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Google Calendar Help</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.85rem", color: "#555" }}>
          <strong>Troubleshooting Google Calendar:</strong>
          <ul style={{ paddingLeft: "1.2rem", marginBottom: "0" }}>
            <li>
              Click <strong>"Allow Cookies"</strong> if prompted.
            </li>
            <li>
              If it still shows <strong>"Learn More"</strong> and doesn't load:
              <ul style={{ paddingLeft: "1rem" }}>
                <li>
                  Open&nbsp;
                  <a
                    href={`https://accounts.google.com/AccountChooser?continue=${encodeURIComponent(
                      `https://calendar.google.com/calendar/u/0/r?cid=${encodeURIComponent(
                        calendarEmail
                      )}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#0061f2" }}
                  >
                    this link
                  </a>
                  &nbsp;to open your calendar directly.
                </li>
              </ul>
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
}
